import {
  initializeWidgetConfiguration,
  SgWidget,
  WidgetConfigurationProvider,
  WithGlobalCss,
} from "@sgwt-widget/core";
import { h } from "preact";
import { emit, props } from "skatejs";
import { MakeGenericAttributeApiCall } from "../common/generic/generic-api";
import {
  IGenericAttributeRequest,
  IGenericAttributeValues,
} from "../common/generic/generic-attribute-types";
import { SCAttributes } from "../common/generic/generic-sc-attributes";
import { generateUniqueId } from "../common/utils/uniqueId";
import { StepSelector } from "./components/StepSelector";

interface IProps {
  userSelection: { [attribute: string]: string[] };
  userEmail: string;
}

class CprSelectStep extends SgWidget<IProps> {
  static get is() {
    return "cpr-select-step";
  }

  public static get props() {
    return {
      userEmail: props.string,
      userSelection: props.object,
    };
  }

  public render(intraprops: IProps) {
    const headers = { uiscreen: (this.constructor as any).is };
    const request: IGenericAttributeRequest = {
      filters: "stepgroup_criterion:1+4",
      includeKpi: false,
    };
    if (
      !this.props.userSelection ||
      !this.props.userSelection[SCAttributes.SC_MARK_STEP_GROUP]
    ) {
      intraprops.userSelection = { [SCAttributes.SC_MARK_STEP_GROUP]: ["4"] };
    }
    const tags =
      intraprops.userSelection &&
      intraprops.userSelection[SCAttributes.SC_MARK_STEP_GROUP]
        ? intraprops.userSelection[SCAttributes.SC_MARK_STEP_GROUP]
        : [];
    const getItems = () =>
      MakeGenericAttributeApiCall(
        headers,
        "sc",
        "stepgroup_criterion",
        request,
        this.widgetConfiguration,
        generateUniqueId()
      ).then((v: IGenericAttributeValues) => this.AppendLevel(v.values));

    const onChange = (value: string[]) => {
      const newValue = { [SCAttributes.SC_MARK_STEP_GROUP]: value };
      intraprops.userSelection = newValue;
      emit(this, "cpr-select-step--filter-changed", {
        detail: { [SCAttributes.SC_MARK_STEP_GROUP]: value },
      });
    };

    return (
      <WidgetConfigurationProvider
        widgetConfiguration={this.widgetConfiguration}
      >
        <WithGlobalCss>
          <StepSelector getItems={getItems} onChange={onChange} tags={tags} />
        </WithGlobalCss>
      </WidgetConfigurationProvider>
    );
  }

  private AppendLevel(values: string[] | undefined): any {
    if (values === undefined) {
      return [];
    }
    return values.map((x: any) => {
      return { Text: `Level ${x}`, Val: x };
    });
  }
}

initializeWidgetConfiguration(CprSelectStep);
customElements.define(CprSelectStep.is, CprSelectStep);
